import {
  checkLogin,
  loadGroup
} from '../service/common'
export default {
  namespaced: true,
  state() {
    return {
      avatar: '',
      name: '',
      id: 0,
      email: '',
      regip: '',
      regregion: ''
    }
  },
  mutations: {
    SAVE_USER(state, {pic,nickname,userid,email,regip,regregion}) {
        state.name = nickname
        state.avatar = pic
        state.id = userid
        state.email = email
        state.regip = regip
        state.regregion = regregion
    }
  },
  actions: {
    checkLogin({commit,dispatch},paload){
      checkLogin(paload,({status,data}) => {
          if (status === 200) {
            commit('SAVE_USER', data)
          } else {
            commit('TOAST', {
              type: 'error',
              msg: data.result
            }, {
              root: true
            })
          }
      })
    },
    loadGroup({commit},paload){
      loadGroup(paload,({status,data}) => {
        if (status === 200) {
          let group
          let autoGroup
          data.groups.map(item => {
            item.type == "special" ? group = item : ""
            item.type == "tmp" ? autoGroup = item : ""
          })
          commit('SAVE_GROUPS',{group,autoGroup},{root: true})
        }
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js